/**
 * @file: constants.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { Option } from '@euler/model';
import { MaterialType, MaterialTypeValueSet } from '@euler/model/enum';
import {
  QuotationMaterialInventoryStatus,
  QuotationMaterialInventoryStatusValueSet,
} from '@euler/model/enum/QuotationMaterialInventoryStatus';

export type MaterialTypeInfo = {
  name: string;
};

export const kMaterialTypes: { [p in MaterialType]: MaterialTypeInfo } = {
  [MaterialType.Oem]: { name: '原厂件' },
  [MaterialType.Brand]: { name: '品牌件' },
  [MaterialType.Aftermarket]: { name: '副厂件' },
  [MaterialType.Salvaged]: { name: '拆车件' },
  [MaterialType.Refurbished]: { name: '翻新件' },
  [MaterialType.Counterfeit]: { name: '高仿件' },
  [MaterialType.Other]: { name: '其他' },
};

export const kMaterialTypeOptions: Option<MaterialType>[] = [
  ...MaterialTypeValueSet,
].map(value => ({ value, text: kMaterialTypes[value]?.name ?? value }));

export type QuotationMaterialInventoryStatusInfo = {
  name: string;
};

export const kQuotationMaterialInventoryStatusInfoMap: {
  [p in QuotationMaterialInventoryStatus]: QuotationMaterialInventoryStatusInfo;
} = {
  [QuotationMaterialInventoryStatus.InStock]: { name: '现货' },
  [QuotationMaterialInventoryStatus.OutOfStock]: { name: '缺货' },
  [QuotationMaterialInventoryStatus.LowStock]: { name: '库存紧张' },
  [QuotationMaterialInventoryStatus.BackOrdered]: { name: '预订中' },
  [QuotationMaterialInventoryStatus.Discontinued]: { name: '停产' },
  [QuotationMaterialInventoryStatus.PreOrder]: { name: '预购' },
  [QuotationMaterialInventoryStatus.Reserved]: { name: '已预留' },
  [QuotationMaterialInventoryStatus.InTransit]: { name: '运输中' },
  [QuotationMaterialInventoryStatus.Pending]: { name: '待定' },
};

export const kQuotationMaterialInventoryStatusOptions: Option<QuotationMaterialInventoryStatus>[] =
  [...QuotationMaterialInventoryStatusValueSet].map(value => ({
    value,
    text: kQuotationMaterialInventoryStatusInfoMap[value]?.name ?? value,
  }));
